import { render, staticRenderFns } from "./GbFooter.vue?vue&type=template&id=4fc0465c&scoped=true"
import script from "./GbFooter.vue?vue&type=script&lang=js"
export * from "./GbFooter.vue?vue&type=script&lang=js"
import style0 from "./GbFooter.vue?vue&type=style&index=0&id=4fc0465c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0465c",
  null
  
)

export default component.exports